import { ApiRoute } from '@routes/apiRoutes';
import { getMimeTypeForExtension, saveBlob } from '@services/exportService';
import { httpService } from '@services/httpService';

export const downloadService = {
  downloadDocument: async (
    recId: string,
    sourcerecid: string,
    fileName?: string
  ): Promise<void> => {
    // Goes through httpService like every other call: the interceptor's 401 and
    // service-maintenance handling applies here too, and its toast is suppressed for this
    // route (toasterConfig) because both download surfaces report their own failures.
    const blob = await httpService.getBlob(
      `${ApiRoute.DocumentDownload}/${recId}/${sourcerecid}`
    );

    const name = fileName || `document-${recId}`;
    saveBlob(blob, name, getMimeTypeForExtension(name.split('.').pop() ?? ''));
  },
};
